import { Injectable } from '@angular/core';

@Injectable()
export class LanguageService {

    static readonly LANG_ENGLISH = "en";
    static readonly LANG_SPANISH = "es";

    private language_string_mappings: any[] = [];
    private custom_string_mappings: any[] = [];

    constructor(
    ) { }

    public addCustomStringMappings(mappings: any[]) {
        this.custom_string_mappings = this.custom_string_mappings.concat(mappings);
    }

    public getStringByKey(string_key: string, language: string = LanguageService.LANG_ENGLISH) {
        // always prioritize custom_string_mappings first
        var mapping = this.custom_string_mappings.find(m => m.key == string_key);
        if (mapping && mapping[language]) return mapping[language];
        // then use the default language_string_mappings last
        mapping = this.language_string_mappings.find(m => m.key == string_key);
        return mapping && mapping[language] ? mapping[language] : "";
    }
}


// WEBPACK FOOTER //
// C:/Azure/Source/Workspaces/SalesNOW/SalesSOLO/WebSites/SalesSOLO.Web.Angular.telesales/src/app/services/language.service.ts